import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9zxdpx73wa: FaireBrandEntity = {
  token: "b_9zxdpx73wa",
  type: "brand",
  name: "Milie",
  avatarUrl:
    "https://cdn.faire.com/fastly/ff586624809e788301975602ba3bcd33f93aa2dd05ddf6ba41f89b55d521ac28.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/635c6a7f3bcc88f66302a57a9e0a838f41163b6e0370a640f3d6e996e01aa442.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ff586624809e788301975602ba3bcd33f93aa2dd05ddf6ba41f89b55d521ac28.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/635c6a7f3bcc88f66302a57a9e0a838f41163b6e0370a640f3d6e996e01aa442.png",
  location: "Miami, FL, USA",
  minimumOrderDollars: 208,
  rating: 4.7,
  reviewCount: 65,
  isInsider: true,
  description:
    "We are a family store established in Miami since 1998, when we boldly decided to move from our homeland, Brazil to this wonderful country of opportunity: the United States of America.\n\nWe brought with us not only courage, but also knowledge of how to make unique jewelry designs. Seeking to show the quality of unique and intricate pieces, we started to establish lasting relationships with loyal customers who wanted exclusive unreachable pieces of jewelry. Thus, creating a bond of trust and ensuring the full satisfaction of the not so explored in the jewelry market, the 18k gold filled quality.\n\nWe believed 100% in our product and make them from scratch developing each piece not only by the fashion trends, but mainly for the requests from the most important people: Our own customers. Thank you so much for being part of our history and our legacy. We will always look forward to transform and make impeccable jewelry ​​made especially with you in our mind and heart.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:10.992Z",
    importedBy: "entity-db-cli",
  },
};
